import colorSchema from '../../color-schema'

export const headingTheme = {
  baseStyle: {
    fontFamily: 'Red Hat Text, sans-serif',
    color: colorSchema.notBlack,
    fontWeight: 700,
  },
}
